import React from 'react';
// import { Redirect } from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import {
    Container,
    CssBaseline,
} from '@material-ui/core';
import {
    Check,
    Clear,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Search,
    Remove,
    ViewColumn,
} from '@material-ui/icons';
import MaterialTable from 'material-table';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import DeleteIcon from '@material-ui/icons/Delete';
import Loading from '../components/Loading';
import Nav from '../components/NavBar/Nav';

import api from '../services/Api';

class Complaints extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            token: '',
            drawer: false,
            redirect: false,
            loading: false,
            columns: [
                {title: 'Id', field: 'id'},
                {title: 'Cliente', field: 'id_client'},
                {title: 'Profissional', field: 'professional'},
                {title: 'Detalhes', field: 'details'},
                {title: 'Data', field: 'created'},
                {title: 'Status', field: 'status'},
            ],
            data: [
                {
                    id: '1',
                    id_client: 'Cliente X',
                    professional: 'Profissional X',
                    details: 'Desacordo sobre procedimento efetuado.',
                    created: '21/05/2020',
                    status: 'Em Análise',
                },
                {
                    id: '2',
                    id_client: 'Cliente Y',
                    professional: 'Profissional Y',
                    details: 'Serviço apresentou problemas 1 mês após a conclusão.',
                    created: '30/09/2020',
                    status: 'Concluído',
                },
            ]
        };
    }

    componentDidMount() {

        this.setState({ loading: true });

        const token = localStorage.getItem('TOKEN_KEY');

        api.post("/admin/check", { }, { headers: { Authorization: 'Bearer ' + token }})
        .then(
            res => {
                if(res.data.status){
                    setTimeout(() => this.setState({ loading: false }), 1000);                 
                }

                if(!res.data.status){
                    setTimeout(() => this.setState({ loading: false }), 1000);                
                }
            }
        ).catch(err => {
            console.log(err);
        })     
    }

    openDrawer = () => {
        this.setState({drawer: !this.state.drawer})
    }

    render() {

        if(this.state.loading) {
            return <Loading />;           
        }

        return (
            <div className={styles.root}>
                <CssBaseline/>
                <Nav />

                <Container maxWidth="lg" style={complaints.table}>
                    <MaterialTable
                        icons={{
                            Check: () => <Check/>,
                            Clear: () => <Clear/>,
                            Export: () => <SaveAlt/>,
                            Filter: () => <FilterList/>,
                            FirstPage: () => <FirstPage/>,
                            LastPage: () => <LastPage/>,
                            NextPage: () => <ChevronRight/>,
                            PreviousPage: () => <ChevronLeft/>,
                            Search: () => <Search/>,
                            ResetSearch: () => <Clear/>,
                            ThirdStateCheck: () => <Remove/>,
                            ViewColumn: () => <ViewColumn/>,
                            DetailPanel: () => <ChevronRight/>
                        }}
                        title="Reclamações"
                        columns={this.state.columns}
                        data={this.state.data}
                        actions={[
                            {
                              icon: () => <RemoveRedEyeIcon/>,
                              tooltip: 'Visualizar',
                              onClick: (event, rowData) => alert("Visualizar informações de " + rowData.name)
                            },
                            rowData => ({
                              icon: () => <DeleteIcon/>,
                              tooltip: 'Deletar Usuário',
                              onClick: (event, rowData) => alert("Você deletou o " + rowData.name),
                              disabled: rowData.birthYear < 2000
                            })
                          ]}
                          options={{
                            actionsColumnIndex: -1
                          }}
                    />
                </Container>

            </div>
        )
    }

}

const complaints = {

    table: {
        marginTop: 50,
    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItens: 'center',       
    },

}

const styles = {
    root: {
        display: 'flex',
    },
    drawer: {
        width: 'auto',
    },
    list: {
        width: 250,
    },
}

export default withStyles(styles)(Complaints);

